import { isWebViewFromCookie } from '@/utils/cookiesHelper';
import ErrorPage from '@/errorManagement/errorPages';
import { SHOP_ERROR_PAGE_TEXT } from './constants';

function ShopError(props) {
  return (
    <ErrorPage
      {...props}
      title={SHOP_ERROR_PAGE_TEXT.TITLE}
      buttonText={SHOP_ERROR_PAGE_TEXT.BUTTON_TEXT}
      buttonHref={SHOP_ERROR_PAGE_TEXT.BUTTON_HREF}
      description={SHOP_ERROR_PAGE_TEXT.DESCRIPTION}
      showLink={false}
      showIcon={false}
      showButtons={!isWebViewFromCookie()}
    />
  );
}
export default ShopError;
